export enum LoyaltyQuestionType {
  Select = 'SELECT',
  Text = 'TEXT',
}

export interface LoyaltySelectOption {
  // Display text, falling back to value
  label?: string;
  // Only visible when the parent question's answer equals this
  parent_value?: string;
  value: string;
}

interface BaseQuestion {
  key: string;
  label: string;
  // Unset counts as required
  required?: boolean;
}

export interface LoyaltySelectQuestion extends BaseQuestion {
  options: LoyaltySelectOption[];
  // When set, options are filtered to those whose parent_value matches the
  // answer to that question
  parent_key?: string;
  type: LoyaltyQuestionType.Select;
}

export interface LoyaltyTextQuestion extends BaseQuestion {
  max_length?: number;
  placeholder?: string;
  type: LoyaltyQuestionType.Text;
}

export type LoyaltyFormQuestion = LoyaltySelectQuestion | LoyaltyTextQuestion;

export interface LoyaltyEnrollmentFormConfig {
  description?: string;
  questions: LoyaltyFormQuestion[];
  title?: string;
}
